export default {
  facebookOGImage: '/facebook-og-default.png',
  mobileWidth: 512,
  tabletLargeWidth: 976,
  cdnUrl: 'http://e.cdn-surfline.com/images/sl_landing/',
  funnelUrl: '/upgrade',
  signInUrl: '/sign-in',
  accountSettingsUrl: '/account/edit-settings',
  createAccountUrl: '/create-account',
  buoyPlotApi: 'https://tile.surfline.com/dashboard/buoyplot.cfm',
  legacyBuoysUrl: 'http://www.surfline.com/surfline/forecasts/realtime_buoys.cfm',
  gravatarUrl: 'https://d14fqx6aetz9ka.cloudfront.net/wp-content/uploads/2017/05/09151618/SL_logo-2-150x150.jpeg',
  mapTileUrl: 'https://maps.tilehosting.com/c/surfline',
  mapTileKey: '3tFgnOQBQixe61aigsBT',
  legacyAPI: 'https://api.surfline.com/v1',
  idealConditionsUrl: legacyId => `http://www.surfline.com/surfdata/report_breakdata_new.cfm?id=${legacyId}`,
  buoySubregionUrl: legacySubregionId => `http://www.surfline.com/surfdata/report_summary_new.cfm?id=${legacySubregionId}&tab=2`,
  tidePredictionUrl: (tideLocation, units) => `http://www.surfline.com/surfdata/inc_spot/window_tide_location.cfm?location=${tideLocation}&units=${units}`,
};



// WEBPACK FOOTER //
// ./src/config/base.js